export default "__VITE_ASSET__2d85b871__"